import { render, staticRenderFns } from "./EtapaCasoEdit.vue?vue&type=template&id=771b6706"
import script from "./EtapaCasoEdit.vue?vue&type=script&lang=js"
export * from "./EtapaCasoEdit.vue?vue&type=script&lang=js"
import style0 from "./EtapaCasoEdit.vue?vue&type=style&index=0&id=771b6706&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports